module.exports = __webpack_public_path__ + "img/ico-16-active.6097670c.svg";